"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v4.24.4
// source: items/items.proto
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FindPublishedRequest = exports.GetPublishedResponse = exports.GetPublishedRequest = exports.UnpublishRequest = exports.PublishRequest = exports.CheckoutRevisionResponse = exports.CheckoutRevisionRequest = exports.UndeleteRequest = exports.DeleteRequest = exports.UpdateRequest = exports.FindResponse = exports.FindRequest = exports.GetResponse = exports.GetRequest = exports.GetOptions = exports.IntrospectResponse = exports.IntrospectRequest = exports.CreateResponse = exports.CreateRequest = exports.AggregatePublishedOptions_FieldsEntry = exports.AggregatePublishedOptions = exports.AggregateOptions_FieldsEntry = exports.AggregateOptions = exports.GetArchivedOptions = exports.GetRevisionOptions = exports.ListRevisionsOptions = exports.FindArchivedOptions = exports.FindPublishedOptions = exports.UnpublishOptions = exports.PublishOptions = exports.UndeleteOptions = exports.DeleteOptions = exports.GetPublishedOptions = exports.UpdateOptions = exports.FindOptions = exports.CreateOptions = exports.Filter = exports.EventDelete = exports.EventUnpublish = exports.EventPublish = exports.EventUpdate = exports.EventCreate = exports.Item_TranslationsEntry = exports.Item = exports.Permissions = exports.ModificationError = exports.ValidationError = exports.DecodeError = exports.Error = exports.Item_State = void 0;
exports.ItemsDefinition = exports.GetArchivedResponse = exports.GetArchivedRequest = exports.FindArchivedResponse = exports.FindArchivedRequest = exports.UnarchiveRequest = exports.ArchiveRequest = exports.ListRevisionsResponse = exports.ListRevisionsRequest = exports.GetRevisionResponse = exports.GetRevisionRequest = exports.AggregatePublishedResponse = exports.AggregatePublishedRequest = exports.AggregateResponse = exports.AggregateRequest = exports.FindPublishedResponse = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const common_1 = require("../common/common");
const error_1 = require("../common/error");
const empty_1 = require("../google/protobuf/empty");
const struct_1 = require("../google/protobuf/struct");
const timestamp_1 = require("../google/protobuf/timestamp");
var Item_State;
(function (Item_State) {
    Item_State[Item_State["DRAFT"] = 0] = "DRAFT";
    Item_State[Item_State["PUBLISHED"] = 1] = "PUBLISHED";
    Item_State[Item_State["CHANGED"] = 2] = "CHANGED";
    Item_State[Item_State["ARCHIVED"] = 3] = "ARCHIVED";
    Item_State[Item_State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Item_State || (exports.Item_State = Item_State = {}));
function createBaseError() {
    return { message: "", field: "" };
}
exports.Error = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        if (message.field !== "") {
            writer.uint32(18).string(message.field);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseError();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.field = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.Error.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseError();
        message.message = (_a = object.message) !== null && _a !== void 0 ? _a : "";
        message.field = (_b = object.field) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseDecodeError() {
    return { errors: [] };
}
exports.DecodeError = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.errors) {
            exports.Error.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDecodeError();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.errors.push(exports.Error.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.DecodeError.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseDecodeError();
        message.errors = ((_a = object.errors) === null || _a === void 0 ? void 0 : _a.map((e) => exports.Error.fromPartial(e))) || [];
        return message;
    },
};
function createBaseValidationError() {
    return { errors: [] };
}
exports.ValidationError = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.errors) {
            exports.Error.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidationError();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.errors.push(exports.Error.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.ValidationError.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseValidationError();
        message.errors = ((_a = object.errors) === null || _a === void 0 ? void 0 : _a.map((e) => exports.Error.fromPartial(e))) || [];
        return message;
    },
};
function createBaseModificationError() {
    return { errors: [] };
}
exports.ModificationError = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.errors) {
            exports.Error.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseModificationError();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.errors.push(exports.Error.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.ModificationError.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseModificationError();
        message.errors = ((_a = object.errors) === null || _a === void 0 ? void 0 : _a.map((e) => exports.Error.fromPartial(e))) || [];
        return message;
    },
};
function createBasePermissions() {
    return { edit: false, archive: false, publish: false, softDelete: false, hardDelete: false };
}
exports.Permissions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.edit !== false) {
            writer.uint32(8).bool(message.edit);
        }
        if (message.archive !== false) {
            writer.uint32(16).bool(message.archive);
        }
        if (message.publish !== false) {
            writer.uint32(24).bool(message.publish);
        }
        if (message.softDelete !== false) {
            writer.uint32(32).bool(message.softDelete);
        }
        if (message.hardDelete !== false) {
            writer.uint32(40).bool(message.hardDelete);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePermissions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.edit = reader.bool();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.archive = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.publish = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.softDelete = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.hardDelete = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.Permissions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBasePermissions();
        message.edit = (_a = object.edit) !== null && _a !== void 0 ? _a : false;
        message.archive = (_b = object.archive) !== null && _b !== void 0 ? _b : false;
        message.publish = (_c = object.publish) !== null && _c !== void 0 ? _c : false;
        message.softDelete = (_d = object.softDelete) !== null && _d !== void 0 ? _d : false;
        message.hardDelete = (_e = object.hardDelete) !== null && _e !== void 0 ? _e : false;
        return message;
    },
};
function createBaseItem() {
    return {
        id: "",
        spaceId: "",
        envId: "",
        collectionId: "",
        state: 0,
        createdRevAt: undefined,
        createdBy: "",
        createdAt: undefined,
        updatedBy: "",
        updatedAt: undefined,
        data: undefined,
        revisionId: "",
        revisionDescription: "",
        deleted: false,
        hidden: false,
        template: false,
        permissions: undefined,
        searchScore: 0,
        localeId: "",
        translations: {},
        translationsIds: [],
    };
}
exports.Item = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.spaceId !== "") {
            writer.uint32(18).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(26).string(message.envId);
        }
        if (message.collectionId !== "") {
            writer.uint32(34).string(message.collectionId);
        }
        if (message.state !== 0) {
            writer.uint32(40).int32(message.state);
        }
        if (message.createdRevAt !== undefined) {
            timestamp_1.Timestamp.encode(message.createdRevAt, writer.uint32(50).fork()).ldelim();
        }
        if (message.createdBy !== "") {
            writer.uint32(58).string(message.createdBy);
        }
        if (message.createdAt !== undefined) {
            timestamp_1.Timestamp.encode(message.createdAt, writer.uint32(66).fork()).ldelim();
        }
        if (message.updatedBy !== "") {
            writer.uint32(74).string(message.updatedBy);
        }
        if (message.updatedAt !== undefined) {
            timestamp_1.Timestamp.encode(message.updatedAt, writer.uint32(82).fork()).ldelim();
        }
        if (message.data !== undefined) {
            struct_1.Struct.encode(struct_1.Struct.wrap(message.data), writer.uint32(90).fork()).ldelim();
        }
        if (message.revisionId !== "") {
            writer.uint32(106).string(message.revisionId);
        }
        if (message.revisionDescription !== "") {
            writer.uint32(114).string(message.revisionDescription);
        }
        if (message.deleted !== false) {
            writer.uint32(152).bool(message.deleted);
        }
        if (message.hidden !== false) {
            writer.uint32(160).bool(message.hidden);
        }
        if (message.template !== false) {
            writer.uint32(168).bool(message.template);
        }
        if (message.permissions !== undefined) {
            exports.Permissions.encode(message.permissions, writer.uint32(178).fork()).ldelim();
        }
        if (message.searchScore !== 0) {
            writer.uint32(185).double(message.searchScore);
        }
        if (message.localeId !== "") {
            writer.uint32(802).string(message.localeId);
        }
        Object.entries(message.translations).forEach(([key, value]) => {
            if (value !== undefined) {
                exports.Item_TranslationsEntry.encode({ key: key, value }, writer.uint32(98).fork()).ldelim();
            }
        });
        for (const v of message.translationsIds) {
            writer.uint32(810).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.state = reader.int32();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.createdRevAt = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.createdBy = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.createdAt = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.updatedBy = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.updatedAt = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.data = struct_1.Struct.unwrap(struct_1.Struct.decode(reader, reader.uint32()));
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.revisionId = reader.string();
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.revisionDescription = reader.string();
                    continue;
                case 19:
                    if (tag !== 152) {
                        break;
                    }
                    message.deleted = reader.bool();
                    continue;
                case 20:
                    if (tag !== 160) {
                        break;
                    }
                    message.hidden = reader.bool();
                    continue;
                case 21:
                    if (tag !== 168) {
                        break;
                    }
                    message.template = reader.bool();
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.permissions = exports.Permissions.decode(reader, reader.uint32());
                    continue;
                case 23:
                    if (tag !== 185) {
                        break;
                    }
                    message.searchScore = reader.double();
                    continue;
                case 100:
                    if (tag !== 802) {
                        break;
                    }
                    message.localeId = reader.string();
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    const entry12 = exports.Item_TranslationsEntry.decode(reader, reader.uint32());
                    if (entry12.value !== undefined) {
                        message.translations[entry12.key] = entry12.value;
                    }
                    continue;
                case 101:
                    if (tag !== 810) {
                        break;
                    }
                    message.translationsIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.Item.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        const message = createBaseItem();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.spaceId = (_b = object.spaceId) !== null && _b !== void 0 ? _b : "";
        message.envId = (_c = object.envId) !== null && _c !== void 0 ? _c : "";
        message.collectionId = (_d = object.collectionId) !== null && _d !== void 0 ? _d : "";
        message.state = (_e = object.state) !== null && _e !== void 0 ? _e : 0;
        message.createdRevAt = (object.createdRevAt !== undefined && object.createdRevAt !== null)
            ? timestamp_1.Timestamp.fromPartial(object.createdRevAt)
            : undefined;
        message.createdBy = (_f = object.createdBy) !== null && _f !== void 0 ? _f : "";
        message.createdAt = (object.createdAt !== undefined && object.createdAt !== null)
            ? timestamp_1.Timestamp.fromPartial(object.createdAt)
            : undefined;
        message.updatedBy = (_g = object.updatedBy) !== null && _g !== void 0 ? _g : "";
        message.updatedAt = (object.updatedAt !== undefined && object.updatedAt !== null)
            ? timestamp_1.Timestamp.fromPartial(object.updatedAt)
            : undefined;
        message.data = (_h = object.data) !== null && _h !== void 0 ? _h : undefined;
        message.revisionId = (_j = object.revisionId) !== null && _j !== void 0 ? _j : "";
        message.revisionDescription = (_k = object.revisionDescription) !== null && _k !== void 0 ? _k : "";
        message.deleted = (_l = object.deleted) !== null && _l !== void 0 ? _l : false;
        message.hidden = (_m = object.hidden) !== null && _m !== void 0 ? _m : false;
        message.template = (_o = object.template) !== null && _o !== void 0 ? _o : false;
        message.permissions = (object.permissions !== undefined && object.permissions !== null)
            ? exports.Permissions.fromPartial(object.permissions)
            : undefined;
        message.searchScore = (_p = object.searchScore) !== null && _p !== void 0 ? _p : 0;
        message.localeId = (_q = object.localeId) !== null && _q !== void 0 ? _q : "";
        message.translations = Object.entries((_r = object.translations) !== null && _r !== void 0 ? _r : {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = value;
            }
            return acc;
        }, {});
        message.translationsIds = ((_s = object.translationsIds) === null || _s === void 0 ? void 0 : _s.map((e) => e)) || [];
        return message;
    },
};
function createBaseItem_TranslationsEntry() {
    return { key: "", value: undefined };
}
exports.Item_TranslationsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            struct_1.Struct.encode(struct_1.Struct.wrap(message.value), writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseItem_TranslationsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = struct_1.Struct.unwrap(struct_1.Struct.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.Item_TranslationsEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseItem_TranslationsEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : undefined;
        return message;
    },
};
function createBaseEventCreate() {
    return { spaceId: "", envId: "", collectionId: "", itemId: "" };
}
exports.EventCreate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(18).string(message.envId);
        }
        if (message.collectionId !== "") {
            writer.uint32(26).string(message.collectionId);
        }
        if (message.itemId !== "") {
            writer.uint32(34).string(message.itemId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventCreate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.EventCreate.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseEventCreate();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.envId = (_b = object.envId) !== null && _b !== void 0 ? _b : "";
        message.collectionId = (_c = object.collectionId) !== null && _c !== void 0 ? _c : "";
        message.itemId = (_d = object.itemId) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseEventUpdate() {
    return { spaceId: "", envId: "", collectionId: "", itemId: "" };
}
exports.EventUpdate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(18).string(message.envId);
        }
        if (message.collectionId !== "") {
            writer.uint32(26).string(message.collectionId);
        }
        if (message.itemId !== "") {
            writer.uint32(34).string(message.itemId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventUpdate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.EventUpdate.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseEventUpdate();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.envId = (_b = object.envId) !== null && _b !== void 0 ? _b : "";
        message.collectionId = (_c = object.collectionId) !== null && _c !== void 0 ? _c : "";
        message.itemId = (_d = object.itemId) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseEventPublish() {
    return { spaceId: "", envId: "", collectionId: "", itemId: "" };
}
exports.EventPublish = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(18).string(message.envId);
        }
        if (message.collectionId !== "") {
            writer.uint32(26).string(message.collectionId);
        }
        if (message.itemId !== "") {
            writer.uint32(34).string(message.itemId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventPublish();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.EventPublish.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseEventPublish();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.envId = (_b = object.envId) !== null && _b !== void 0 ? _b : "";
        message.collectionId = (_c = object.collectionId) !== null && _c !== void 0 ? _c : "";
        message.itemId = (_d = object.itemId) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseEventUnpublish() {
    return { spaceId: "", envId: "", collectionId: "", itemId: "" };
}
exports.EventUnpublish = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(18).string(message.envId);
        }
        if (message.collectionId !== "") {
            writer.uint32(26).string(message.collectionId);
        }
        if (message.itemId !== "") {
            writer.uint32(34).string(message.itemId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventUnpublish();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.EventUnpublish.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseEventUnpublish();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.envId = (_b = object.envId) !== null && _b !== void 0 ? _b : "";
        message.collectionId = (_c = object.collectionId) !== null && _c !== void 0 ? _c : "";
        message.itemId = (_d = object.itemId) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseEventDelete() {
    return { spaceId: "", envId: "", collectionId: "", itemId: "" };
}
exports.EventDelete = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(18).string(message.envId);
        }
        if (message.collectionId !== "") {
            writer.uint32(26).string(message.collectionId);
        }
        if (message.itemId !== "") {
            writer.uint32(34).string(message.itemId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEventDelete();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.EventDelete.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseEventDelete();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.envId = (_b = object.envId) !== null && _b !== void 0 ? _b : "";
        message.collectionId = (_c = object.collectionId) !== null && _c !== void 0 ? _c : "";
        message.itemId = (_d = object.itemId) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseFilter() {
    return { id: [], data: [], q: [] };
}
exports.Filter = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.id) {
            writer.uint32(10).string(v);
        }
        for (const v of message.data) {
            common_1.Filter.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.q) {
            writer.uint32(26).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFilter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id.push(reader.string());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data.push(common_1.Filter.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.q.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.Filter.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseFilter();
        message.id = ((_a = object.id) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        message.data = ((_b = object.data) === null || _b === void 0 ? void 0 : _b.map((e) => common_1.Filter.fromPartial(e))) || [];
        message.q = ((_c = object.q) === null || _c === void 0 ? void 0 : _c.map((e) => e)) || [];
        return message;
    },
};
function createBaseCreateOptions() {
    return { updateAttrs: false };
}
exports.CreateOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.updateAttrs !== false) {
            writer.uint32(8).bool(message.updateAttrs);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCreateOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.updateAttrs = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.CreateOptions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseCreateOptions();
        message.updateAttrs = (_a = object.updateAttrs) !== null && _a !== void 0 ? _a : false;
        return message;
    },
};
function createBaseFindOptions() {
    return {
        options: undefined,
        deleted: false,
        regular: false,
        hidden: false,
        templates: false,
        localeId: "",
        translationsIds: [],
    };
}
exports.FindOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.options !== undefined) {
            common_1.FindOptions.encode(message.options, writer.uint32(18).fork()).ldelim();
        }
        if (message.deleted !== false) {
            writer.uint32(24).bool(message.deleted);
        }
        if (message.regular !== false) {
            writer.uint32(32).bool(message.regular);
        }
        if (message.hidden !== false) {
            writer.uint32(40).bool(message.hidden);
        }
        if (message.templates !== false) {
            writer.uint32(48).bool(message.templates);
        }
        if (message.localeId !== "") {
            writer.uint32(58).string(message.localeId);
        }
        for (const v of message.translationsIds) {
            writer.uint32(66).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFindOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.options = common_1.FindOptions.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.deleted = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.regular = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.hidden = reader.bool();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.templates = reader.bool();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.localeId = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.translationsIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.FindOptions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseFindOptions();
        message.options = (object.options !== undefined && object.options !== null)
            ? common_1.FindOptions.fromPartial(object.options)
            : undefined;
        message.deleted = (_a = object.deleted) !== null && _a !== void 0 ? _a : false;
        message.regular = (_b = object.regular) !== null && _b !== void 0 ? _b : false;
        message.hidden = (_c = object.hidden) !== null && _c !== void 0 ? _c : false;
        message.templates = (_d = object.templates) !== null && _d !== void 0 ? _d : false;
        message.localeId = (_e = object.localeId) !== null && _e !== void 0 ? _e : "";
        message.translationsIds = ((_f = object.translationsIds) === null || _f === void 0 ? void 0 : _f.map((e) => e)) || [];
        return message;
    },
};
function createBaseUpdateOptions() {
    return { updateAttrs: false };
}
exports.UpdateOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.updateAttrs !== false) {
            writer.uint32(8).bool(message.updateAttrs);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.updateAttrs = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.UpdateOptions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseUpdateOptions();
        message.updateAttrs = (_a = object.updateAttrs) !== null && _a !== void 0 ? _a : false;
        return message;
    },
};
function createBaseGetPublishedOptions() {
    return { localeId: "", translationsIds: [] };
}
exports.GetPublishedOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.localeId !== "") {
            writer.uint32(58).string(message.localeId);
        }
        for (const v of message.translationsIds) {
            writer.uint32(66).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetPublishedOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.localeId = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.translationsIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.GetPublishedOptions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseGetPublishedOptions();
        message.localeId = (_a = object.localeId) !== null && _a !== void 0 ? _a : "";
        message.translationsIds = ((_b = object.translationsIds) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        return message;
    },
};
function createBaseDeleteOptions() {
    return { updateAttrs: false, erase: false };
}
exports.DeleteOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.updateAttrs !== false) {
            writer.uint32(8).bool(message.updateAttrs);
        }
        if (message.erase !== false) {
            writer.uint32(16).bool(message.erase);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeleteOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.updateAttrs = reader.bool();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.erase = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.DeleteOptions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseDeleteOptions();
        message.updateAttrs = (_a = object.updateAttrs) !== null && _a !== void 0 ? _a : false;
        message.erase = (_b = object.erase) !== null && _b !== void 0 ? _b : false;
        return message;
    },
};
function createBaseUndeleteOptions() {
    return { updateAttrs: false };
}
exports.UndeleteOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.updateAttrs !== false) {
            writer.uint32(8).bool(message.updateAttrs);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUndeleteOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.updateAttrs = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.UndeleteOptions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseUndeleteOptions();
        message.updateAttrs = (_a = object.updateAttrs) !== null && _a !== void 0 ? _a : false;
        return message;
    },
};
function createBasePublishOptions() {
    return { updateAttrs: false };
}
exports.PublishOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.updateAttrs !== false) {
            writer.uint32(8).bool(message.updateAttrs);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePublishOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.updateAttrs = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.PublishOptions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBasePublishOptions();
        message.updateAttrs = (_a = object.updateAttrs) !== null && _a !== void 0 ? _a : false;
        return message;
    },
};
function createBaseUnpublishOptions() {
    return { updateAttrs: false };
}
exports.UnpublishOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.updateAttrs !== false) {
            writer.uint32(8).bool(message.updateAttrs);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnpublishOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.updateAttrs = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.UnpublishOptions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseUnpublishOptions();
        message.updateAttrs = (_a = object.updateAttrs) !== null && _a !== void 0 ? _a : false;
        return message;
    },
};
function createBaseFindPublishedOptions() {
    return { options: undefined, regular: false, hidden: false, templates: false, localeId: "", translationsIds: [] };
}
exports.FindPublishedOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.options !== undefined) {
            common_1.FindOptions.encode(message.options, writer.uint32(18).fork()).ldelim();
        }
        if (message.regular !== false) {
            writer.uint32(32).bool(message.regular);
        }
        if (message.hidden !== false) {
            writer.uint32(40).bool(message.hidden);
        }
        if (message.templates !== false) {
            writer.uint32(48).bool(message.templates);
        }
        if (message.localeId !== "") {
            writer.uint32(58).string(message.localeId);
        }
        for (const v of message.translationsIds) {
            writer.uint32(66).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFindPublishedOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.options = common_1.FindOptions.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.regular = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.hidden = reader.bool();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.templates = reader.bool();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.localeId = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.translationsIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.FindPublishedOptions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseFindPublishedOptions();
        message.options = (object.options !== undefined && object.options !== null)
            ? common_1.FindOptions.fromPartial(object.options)
            : undefined;
        message.regular = (_a = object.regular) !== null && _a !== void 0 ? _a : false;
        message.hidden = (_b = object.hidden) !== null && _b !== void 0 ? _b : false;
        message.templates = (_c = object.templates) !== null && _c !== void 0 ? _c : false;
        message.localeId = (_d = object.localeId) !== null && _d !== void 0 ? _d : "";
        message.translationsIds = ((_e = object.translationsIds) === null || _e === void 0 ? void 0 : _e.map((e) => e)) || [];
        return message;
    },
};
function createBaseFindArchivedOptions() {
    return { options: undefined, localeId: "", translationsIds: [] };
}
exports.FindArchivedOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.options !== undefined) {
            common_1.FindOptions.encode(message.options, writer.uint32(18).fork()).ldelim();
        }
        if (message.localeId !== "") {
            writer.uint32(58).string(message.localeId);
        }
        for (const v of message.translationsIds) {
            writer.uint32(66).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFindArchivedOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.options = common_1.FindOptions.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.localeId = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.translationsIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.FindArchivedOptions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseFindArchivedOptions();
        message.options = (object.options !== undefined && object.options !== null)
            ? common_1.FindOptions.fromPartial(object.options)
            : undefined;
        message.localeId = (_a = object.localeId) !== null && _a !== void 0 ? _a : "";
        message.translationsIds = ((_b = object.translationsIds) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        return message;
    },
};
function createBaseListRevisionsOptions() {
    return { offset: 0, limit: 0, fields: [], excludeFields: false, localeId: "", translationsIds: [] };
}
exports.ListRevisionsOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.offset !== 0) {
            writer.uint32(72).int32(message.offset);
        }
        if (message.limit !== 0) {
            writer.uint32(80).int32(message.limit);
        }
        for (const v of message.fields) {
            writer.uint32(90).string(v);
        }
        if (message.excludeFields !== false) {
            writer.uint32(96).bool(message.excludeFields);
        }
        if (message.localeId !== "") {
            writer.uint32(58).string(message.localeId);
        }
        for (const v of message.translationsIds) {
            writer.uint32(66).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListRevisionsOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.offset = reader.int32();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.limit = reader.int32();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.fields.push(reader.string());
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.excludeFields = reader.bool();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.localeId = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.translationsIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.ListRevisionsOptions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseListRevisionsOptions();
        message.offset = (_a = object.offset) !== null && _a !== void 0 ? _a : 0;
        message.limit = (_b = object.limit) !== null && _b !== void 0 ? _b : 0;
        message.fields = ((_c = object.fields) === null || _c === void 0 ? void 0 : _c.map((e) => e)) || [];
        message.excludeFields = (_d = object.excludeFields) !== null && _d !== void 0 ? _d : false;
        message.localeId = (_e = object.localeId) !== null && _e !== void 0 ? _e : "";
        message.translationsIds = ((_f = object.translationsIds) === null || _f === void 0 ? void 0 : _f.map((e) => e)) || [];
        return message;
    },
};
function createBaseGetRevisionOptions() {
    return { localeId: "", translationsIds: [] };
}
exports.GetRevisionOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.localeId !== "") {
            writer.uint32(58).string(message.localeId);
        }
        for (const v of message.translationsIds) {
            writer.uint32(66).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetRevisionOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.localeId = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.translationsIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.GetRevisionOptions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseGetRevisionOptions();
        message.localeId = (_a = object.localeId) !== null && _a !== void 0 ? _a : "";
        message.translationsIds = ((_b = object.translationsIds) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        return message;
    },
};
function createBaseGetArchivedOptions() {
    return { localeId: "", translationsIds: [] };
}
exports.GetArchivedOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.localeId !== "") {
            writer.uint32(58).string(message.localeId);
        }
        for (const v of message.translationsIds) {
            writer.uint32(66).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetArchivedOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.localeId = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.translationsIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.GetArchivedOptions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseGetArchivedOptions();
        message.localeId = (_a = object.localeId) !== null && _a !== void 0 ? _a : "";
        message.translationsIds = ((_b = object.translationsIds) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        return message;
    },
};
function createBaseAggregateOptions() {
    return { fields: {} };
}
exports.AggregateOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.fields).forEach(([key, value]) => {
            exports.AggregateOptions_FieldsEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAggregateOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = exports.AggregateOptions_FieldsEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.fields[entry1.key] = entry1.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.AggregateOptions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseAggregateOptions();
        message.fields = Object.entries((_a = object.fields) !== null && _a !== void 0 ? _a : {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseAggregateOptions_FieldsEntry() {
    return { key: "", value: "" };
}
exports.AggregateOptions_FieldsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAggregateOptions_FieldsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.AggregateOptions_FieldsEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseAggregateOptions_FieldsEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseAggregatePublishedOptions() {
    return { fields: {} };
}
exports.AggregatePublishedOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.fields).forEach(([key, value]) => {
            exports.AggregatePublishedOptions_FieldsEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAggregatePublishedOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = exports.AggregatePublishedOptions_FieldsEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.fields[entry1.key] = entry1.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.AggregatePublishedOptions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseAggregatePublishedOptions();
        message.fields = Object.entries((_a = object.fields) !== null && _a !== void 0 ? _a : {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseAggregatePublishedOptions_FieldsEntry() {
    return { key: "", value: "" };
}
exports.AggregatePublishedOptions_FieldsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAggregatePublishedOptions_FieldsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.AggregatePublishedOptions_FieldsEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseAggregatePublishedOptions_FieldsEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseCreateRequest() {
    return { item: undefined, options: undefined };
}
exports.CreateRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.item !== undefined) {
            exports.Item.encode(message.item, writer.uint32(10).fork()).ldelim();
        }
        if (message.options !== undefined) {
            exports.CreateOptions.encode(message.options, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCreateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.item = exports.Item.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.options = exports.CreateOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.CreateRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseCreateRequest();
        message.item = (object.item !== undefined && object.item !== null) ? exports.Item.fromPartial(object.item) : undefined;
        message.options = (object.options !== undefined && object.options !== null)
            ? exports.CreateOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseCreateResponse() {
    return { created: undefined };
}
exports.CreateResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.created !== undefined) {
            exports.Item.encode(message.created, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCreateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.created = exports.Item.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.CreateResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseCreateResponse();
        message.created = (object.created !== undefined && object.created !== null)
            ? exports.Item.fromPartial(object.created)
            : undefined;
        return message;
    },
};
function createBaseIntrospectRequest() {
    return { item: undefined };
}
exports.IntrospectRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.item !== undefined) {
            exports.Item.encode(message.item, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIntrospectRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.item = exports.Item.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.IntrospectRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseIntrospectRequest();
        message.item = (object.item !== undefined && object.item !== null) ? exports.Item.fromPartial(object.item) : undefined;
        return message;
    },
};
function createBaseIntrospectResponse() {
    return { item: undefined, schema: "", validationErrors: [] };
}
exports.IntrospectResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.item !== undefined) {
            exports.Item.encode(message.item, writer.uint32(10).fork()).ldelim();
        }
        if (message.schema !== "") {
            writer.uint32(18).string(message.schema);
        }
        for (const v of message.validationErrors) {
            error_1.Error_BadRequest_FieldViolation.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIntrospectResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.item = exports.Item.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.schema = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.validationErrors.push(error_1.Error_BadRequest_FieldViolation.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.IntrospectResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseIntrospectResponse();
        message.item = (object.item !== undefined && object.item !== null) ? exports.Item.fromPartial(object.item) : undefined;
        message.schema = (_a = object.schema) !== null && _a !== void 0 ? _a : "";
        message.validationErrors = ((_b = object.validationErrors) === null || _b === void 0 ? void 0 : _b.map((e) => error_1.Error_BadRequest_FieldViolation.fromPartial(e))) ||
            [];
        return message;
    },
};
function createBaseGetOptions() {
    return { localeId: "", translationsIds: [] };
}
exports.GetOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.localeId !== "") {
            writer.uint32(58).string(message.localeId);
        }
        for (const v of message.translationsIds) {
            writer.uint32(66).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.localeId = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.translationsIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.GetOptions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseGetOptions();
        message.localeId = (_a = object.localeId) !== null && _a !== void 0 ? _a : "";
        message.translationsIds = ((_b = object.translationsIds) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        return message;
    },
};
function createBaseGetRequest() {
    return { spaceId: "", envId: "", collectionId: "", itemId: "", options: undefined };
}
exports.GetRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(18).string(message.envId);
        }
        if (message.collectionId !== "") {
            writer.uint32(26).string(message.collectionId);
        }
        if (message.itemId !== "") {
            writer.uint32(34).string(message.itemId);
        }
        if (message.options !== undefined) {
            exports.GetOptions.encode(message.options, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.options = exports.GetOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.GetRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseGetRequest();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.envId = (_b = object.envId) !== null && _b !== void 0 ? _b : "";
        message.collectionId = (_c = object.collectionId) !== null && _c !== void 0 ? _c : "";
        message.itemId = (_d = object.itemId) !== null && _d !== void 0 ? _d : "";
        message.options = (object.options !== undefined && object.options !== null)
            ? exports.GetOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseGetResponse() {
    return { item: undefined };
}
exports.GetResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.item !== undefined) {
            exports.Item.encode(message.item, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.item = exports.Item.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.GetResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseGetResponse();
        message.item = (object.item !== undefined && object.item !== null) ? exports.Item.fromPartial(object.item) : undefined;
        return message;
    },
};
function createBaseFindRequest() {
    return { spaceId: "", envId: "", collectionId: "", filter: undefined, options: undefined };
}
exports.FindRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(18).string(message.envId);
        }
        if (message.collectionId !== "") {
            writer.uint32(26).string(message.collectionId);
        }
        if (message.filter !== undefined) {
            exports.Filter.encode(message.filter, writer.uint32(34).fork()).ldelim();
        }
        if (message.options !== undefined) {
            exports.FindOptions.encode(message.options, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFindRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.filter = exports.Filter.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.options = exports.FindOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.FindRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseFindRequest();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.envId = (_b = object.envId) !== null && _b !== void 0 ? _b : "";
        message.collectionId = (_c = object.collectionId) !== null && _c !== void 0 ? _c : "";
        message.filter = (object.filter !== undefined && object.filter !== null)
            ? exports.Filter.fromPartial(object.filter)
            : undefined;
        message.options = (object.options !== undefined && object.options !== null)
            ? exports.FindOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseFindResponse() {
    return { items: [], total: 0 };
}
exports.FindResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.items) {
            exports.Item.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.total !== 0) {
            writer.uint32(16).int32(message.total);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFindResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.items.push(exports.Item.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.total = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.FindResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseFindResponse();
        message.items = ((_a = object.items) === null || _a === void 0 ? void 0 : _a.map((e) => exports.Item.fromPartial(e))) || [];
        message.total = (_b = object.total) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseUpdateRequest() {
    return { item: undefined, options: undefined };
}
exports.UpdateRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.item !== undefined) {
            exports.Item.encode(message.item, writer.uint32(10).fork()).ldelim();
        }
        if (message.options !== undefined) {
            exports.UpdateOptions.encode(message.options, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.item = exports.Item.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.options = exports.UpdateOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.UpdateRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseUpdateRequest();
        message.item = (object.item !== undefined && object.item !== null) ? exports.Item.fromPartial(object.item) : undefined;
        message.options = (object.options !== undefined && object.options !== null)
            ? exports.UpdateOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseDeleteRequest() {
    return { item: undefined, options: undefined };
}
exports.DeleteRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.item !== undefined) {
            exports.Item.encode(message.item, writer.uint32(10).fork()).ldelim();
        }
        if (message.options !== undefined) {
            exports.DeleteOptions.encode(message.options, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeleteRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.item = exports.Item.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.options = exports.DeleteOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.DeleteRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseDeleteRequest();
        message.item = (object.item !== undefined && object.item !== null) ? exports.Item.fromPartial(object.item) : undefined;
        message.options = (object.options !== undefined && object.options !== null)
            ? exports.DeleteOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseUndeleteRequest() {
    return { item: undefined, options: undefined };
}
exports.UndeleteRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.item !== undefined) {
            exports.Item.encode(message.item, writer.uint32(10).fork()).ldelim();
        }
        if (message.options !== undefined) {
            exports.UndeleteOptions.encode(message.options, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUndeleteRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.item = exports.Item.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.options = exports.UndeleteOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.UndeleteRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseUndeleteRequest();
        message.item = (object.item !== undefined && object.item !== null) ? exports.Item.fromPartial(object.item) : undefined;
        message.options = (object.options !== undefined && object.options !== null)
            ? exports.UndeleteOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseCheckoutRevisionRequest() {
    return { spaceId: "", envId: "", collectionId: "", itemId: "", revisionId: "" };
}
exports.CheckoutRevisionRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(18).string(message.envId);
        }
        if (message.collectionId !== "") {
            writer.uint32(26).string(message.collectionId);
        }
        if (message.itemId !== "") {
            writer.uint32(34).string(message.itemId);
        }
        if (message.revisionId !== "") {
            writer.uint32(42).string(message.revisionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCheckoutRevisionRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.revisionId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.CheckoutRevisionRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseCheckoutRevisionRequest();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.envId = (_b = object.envId) !== null && _b !== void 0 ? _b : "";
        message.collectionId = (_c = object.collectionId) !== null && _c !== void 0 ? _c : "";
        message.itemId = (_d = object.itemId) !== null && _d !== void 0 ? _d : "";
        message.revisionId = (_e = object.revisionId) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
function createBaseCheckoutRevisionResponse() {
    return { storedRevisionId: "" };
}
exports.CheckoutRevisionResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.storedRevisionId !== "") {
            writer.uint32(10).string(message.storedRevisionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCheckoutRevisionResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.storedRevisionId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.CheckoutRevisionResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseCheckoutRevisionResponse();
        message.storedRevisionId = (_a = object.storedRevisionId) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBasePublishRequest() {
    return { item: undefined, options: undefined };
}
exports.PublishRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.item !== undefined) {
            exports.Item.encode(message.item, writer.uint32(10).fork()).ldelim();
        }
        if (message.options !== undefined) {
            exports.PublishOptions.encode(message.options, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePublishRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.item = exports.Item.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.options = exports.PublishOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.PublishRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBasePublishRequest();
        message.item = (object.item !== undefined && object.item !== null) ? exports.Item.fromPartial(object.item) : undefined;
        message.options = (object.options !== undefined && object.options !== null)
            ? exports.PublishOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseUnpublishRequest() {
    return { item: undefined, options: undefined };
}
exports.UnpublishRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.item !== undefined) {
            exports.Item.encode(message.item, writer.uint32(10).fork()).ldelim();
        }
        if (message.options !== undefined) {
            exports.UnpublishOptions.encode(message.options, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnpublishRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.item = exports.Item.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.options = exports.UnpublishOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.UnpublishRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseUnpublishRequest();
        message.item = (object.item !== undefined && object.item !== null) ? exports.Item.fromPartial(object.item) : undefined;
        message.options = (object.options !== undefined && object.options !== null)
            ? exports.UnpublishOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseGetPublishedRequest() {
    return { spaceId: "", envId: "", collectionId: "", itemId: "", options: undefined };
}
exports.GetPublishedRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(18).string(message.envId);
        }
        if (message.collectionId !== "") {
            writer.uint32(26).string(message.collectionId);
        }
        if (message.itemId !== "") {
            writer.uint32(42).string(message.itemId);
        }
        if (message.options !== undefined) {
            exports.GetPublishedOptions.encode(message.options, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetPublishedRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.options = exports.GetPublishedOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.GetPublishedRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseGetPublishedRequest();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.envId = (_b = object.envId) !== null && _b !== void 0 ? _b : "";
        message.collectionId = (_c = object.collectionId) !== null && _c !== void 0 ? _c : "";
        message.itemId = (_d = object.itemId) !== null && _d !== void 0 ? _d : "";
        message.options = (object.options !== undefined && object.options !== null)
            ? exports.GetPublishedOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseGetPublishedResponse() {
    return { item: undefined };
}
exports.GetPublishedResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.item !== undefined) {
            exports.Item.encode(message.item, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetPublishedResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.item = exports.Item.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.GetPublishedResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseGetPublishedResponse();
        message.item = (object.item !== undefined && object.item !== null) ? exports.Item.fromPartial(object.item) : undefined;
        return message;
    },
};
function createBaseFindPublishedRequest() {
    return { spaceId: "", envId: "", collectionId: "", filter: undefined, options: undefined };
}
exports.FindPublishedRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(18).string(message.envId);
        }
        if (message.collectionId !== "") {
            writer.uint32(26).string(message.collectionId);
        }
        if (message.filter !== undefined) {
            exports.Filter.encode(message.filter, writer.uint32(34).fork()).ldelim();
        }
        if (message.options !== undefined) {
            exports.FindPublishedOptions.encode(message.options, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFindPublishedRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.filter = exports.Filter.decode(reader, reader.uint32());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.options = exports.FindPublishedOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.FindPublishedRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseFindPublishedRequest();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.envId = (_b = object.envId) !== null && _b !== void 0 ? _b : "";
        message.collectionId = (_c = object.collectionId) !== null && _c !== void 0 ? _c : "";
        message.filter = (object.filter !== undefined && object.filter !== null)
            ? exports.Filter.fromPartial(object.filter)
            : undefined;
        message.options = (object.options !== undefined && object.options !== null)
            ? exports.FindPublishedOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseFindPublishedResponse() {
    return { items: [], total: 0 };
}
exports.FindPublishedResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.items) {
            exports.Item.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.total !== 0) {
            writer.uint32(16).int32(message.total);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFindPublishedResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.items.push(exports.Item.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.total = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.FindPublishedResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseFindPublishedResponse();
        message.items = ((_a = object.items) === null || _a === void 0 ? void 0 : _a.map((e) => exports.Item.fromPartial(e))) || [];
        message.total = (_b = object.total) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseAggregateRequest() {
    return { spaceId: "", envId: "", collectionId: "", filter: undefined, options: undefined };
}
exports.AggregateRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(18).string(message.envId);
        }
        if (message.collectionId !== "") {
            writer.uint32(26).string(message.collectionId);
        }
        if (message.filter !== undefined) {
            exports.Filter.encode(message.filter, writer.uint32(34).fork()).ldelim();
        }
        if (message.options !== undefined) {
            exports.AggregateOptions.encode(message.options, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAggregateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.filter = exports.Filter.decode(reader, reader.uint32());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.options = exports.AggregateOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.AggregateRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseAggregateRequest();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.envId = (_b = object.envId) !== null && _b !== void 0 ? _b : "";
        message.collectionId = (_c = object.collectionId) !== null && _c !== void 0 ? _c : "";
        message.filter = (object.filter !== undefined && object.filter !== null)
            ? exports.Filter.fromPartial(object.filter)
            : undefined;
        message.options = (object.options !== undefined && object.options !== null)
            ? exports.AggregateOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseAggregateResponse() {
    return { result: undefined };
}
exports.AggregateResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.result !== undefined) {
            struct_1.Struct.encode(struct_1.Struct.wrap(message.result), writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAggregateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.result = struct_1.Struct.unwrap(struct_1.Struct.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.AggregateResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseAggregateResponse();
        message.result = (_a = object.result) !== null && _a !== void 0 ? _a : undefined;
        return message;
    },
};
function createBaseAggregatePublishedRequest() {
    return { spaceId: "", envId: "", collectionId: "", filter: undefined, options: undefined };
}
exports.AggregatePublishedRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(18).string(message.envId);
        }
        if (message.collectionId !== "") {
            writer.uint32(26).string(message.collectionId);
        }
        if (message.filter !== undefined) {
            exports.Filter.encode(message.filter, writer.uint32(34).fork()).ldelim();
        }
        if (message.options !== undefined) {
            exports.AggregatePublishedOptions.encode(message.options, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAggregatePublishedRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.filter = exports.Filter.decode(reader, reader.uint32());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.options = exports.AggregatePublishedOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.AggregatePublishedRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseAggregatePublishedRequest();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.envId = (_b = object.envId) !== null && _b !== void 0 ? _b : "";
        message.collectionId = (_c = object.collectionId) !== null && _c !== void 0 ? _c : "";
        message.filter = (object.filter !== undefined && object.filter !== null)
            ? exports.Filter.fromPartial(object.filter)
            : undefined;
        message.options = (object.options !== undefined && object.options !== null)
            ? exports.AggregatePublishedOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseAggregatePublishedResponse() {
    return { result: undefined };
}
exports.AggregatePublishedResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.result !== undefined) {
            struct_1.Struct.encode(struct_1.Struct.wrap(message.result), writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAggregatePublishedResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.result = struct_1.Struct.unwrap(struct_1.Struct.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.AggregatePublishedResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseAggregatePublishedResponse();
        message.result = (_a = object.result) !== null && _a !== void 0 ? _a : undefined;
        return message;
    },
};
function createBaseGetRevisionRequest() {
    return { spaceId: "", envId: "", collectionId: "", itemId: "", revisionId: "", options: undefined };
}
exports.GetRevisionRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(18).string(message.envId);
        }
        if (message.collectionId !== "") {
            writer.uint32(26).string(message.collectionId);
        }
        if (message.itemId !== "") {
            writer.uint32(34).string(message.itemId);
        }
        if (message.revisionId !== "") {
            writer.uint32(42).string(message.revisionId);
        }
        if (message.options !== undefined) {
            exports.GetRevisionOptions.encode(message.options, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetRevisionRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.revisionId = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.options = exports.GetRevisionOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.GetRevisionRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseGetRevisionRequest();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.envId = (_b = object.envId) !== null && _b !== void 0 ? _b : "";
        message.collectionId = (_c = object.collectionId) !== null && _c !== void 0 ? _c : "";
        message.itemId = (_d = object.itemId) !== null && _d !== void 0 ? _d : "";
        message.revisionId = (_e = object.revisionId) !== null && _e !== void 0 ? _e : "";
        message.options = (object.options !== undefined && object.options !== null)
            ? exports.GetRevisionOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseGetRevisionResponse() {
    return { item: undefined };
}
exports.GetRevisionResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.item !== undefined) {
            exports.Item.encode(message.item, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetRevisionResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.item = exports.Item.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.GetRevisionResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseGetRevisionResponse();
        message.item = (object.item !== undefined && object.item !== null) ? exports.Item.fromPartial(object.item) : undefined;
        return message;
    },
};
function createBaseListRevisionsRequest() {
    return { spaceId: "", envId: "", collectionId: "", itemId: "", options: undefined };
}
exports.ListRevisionsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(18).string(message.envId);
        }
        if (message.collectionId !== "") {
            writer.uint32(26).string(message.collectionId);
        }
        if (message.itemId !== "") {
            writer.uint32(34).string(message.itemId);
        }
        if (message.options !== undefined) {
            exports.ListRevisionsOptions.encode(message.options, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListRevisionsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.options = exports.ListRevisionsOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.ListRevisionsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseListRevisionsRequest();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.envId = (_b = object.envId) !== null && _b !== void 0 ? _b : "";
        message.collectionId = (_c = object.collectionId) !== null && _c !== void 0 ? _c : "";
        message.itemId = (_d = object.itemId) !== null && _d !== void 0 ? _d : "";
        message.options = (object.options !== undefined && object.options !== null)
            ? exports.ListRevisionsOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseListRevisionsResponse() {
    return { items: [], total: 0 };
}
exports.ListRevisionsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.items) {
            exports.Item.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.total !== 0) {
            writer.uint32(16).int32(message.total);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListRevisionsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.items.push(exports.Item.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.total = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.ListRevisionsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseListRevisionsResponse();
        message.items = ((_a = object.items) === null || _a === void 0 ? void 0 : _a.map((e) => exports.Item.fromPartial(e))) || [];
        message.total = (_b = object.total) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseArchiveRequest() {
    return { item: undefined };
}
exports.ArchiveRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.item !== undefined) {
            exports.Item.encode(message.item, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseArchiveRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.item = exports.Item.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.ArchiveRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseArchiveRequest();
        message.item = (object.item !== undefined && object.item !== null) ? exports.Item.fromPartial(object.item) : undefined;
        return message;
    },
};
function createBaseUnarchiveRequest() {
    return { item: undefined };
}
exports.UnarchiveRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.item !== undefined) {
            exports.Item.encode(message.item, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnarchiveRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.item = exports.Item.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.UnarchiveRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseUnarchiveRequest();
        message.item = (object.item !== undefined && object.item !== null) ? exports.Item.fromPartial(object.item) : undefined;
        return message;
    },
};
function createBaseFindArchivedRequest() {
    return { spaceId: "", envId: "", collectionId: "", filter: undefined, options: undefined };
}
exports.FindArchivedRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(18).string(message.envId);
        }
        if (message.collectionId !== "") {
            writer.uint32(26).string(message.collectionId);
        }
        if (message.filter !== undefined) {
            exports.Filter.encode(message.filter, writer.uint32(34).fork()).ldelim();
        }
        if (message.options !== undefined) {
            exports.FindArchivedOptions.encode(message.options, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFindArchivedRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.filter = exports.Filter.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.options = exports.FindArchivedOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.FindArchivedRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseFindArchivedRequest();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.envId = (_b = object.envId) !== null && _b !== void 0 ? _b : "";
        message.collectionId = (_c = object.collectionId) !== null && _c !== void 0 ? _c : "";
        message.filter = (object.filter !== undefined && object.filter !== null)
            ? exports.Filter.fromPartial(object.filter)
            : undefined;
        message.options = (object.options !== undefined && object.options !== null)
            ? exports.FindArchivedOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseFindArchivedResponse() {
    return { items: [], total: 0 };
}
exports.FindArchivedResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.items) {
            exports.Item.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.total !== 0) {
            writer.uint32(16).int32(message.total);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFindArchivedResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.items.push(exports.Item.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.total = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.FindArchivedResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseFindArchivedResponse();
        message.items = ((_a = object.items) === null || _a === void 0 ? void 0 : _a.map((e) => exports.Item.fromPartial(e))) || [];
        message.total = (_b = object.total) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseGetArchivedRequest() {
    return { spaceId: "", envId: "", collectionId: "", itemId: "", options: undefined };
}
exports.GetArchivedRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(18).string(message.envId);
        }
        if (message.collectionId !== "") {
            writer.uint32(26).string(message.collectionId);
        }
        if (message.itemId !== "") {
            writer.uint32(34).string(message.itemId);
        }
        if (message.options !== undefined) {
            exports.GetArchivedOptions.encode(message.options, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetArchivedRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.options = exports.GetArchivedOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.GetArchivedRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseGetArchivedRequest();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.envId = (_b = object.envId) !== null && _b !== void 0 ? _b : "";
        message.collectionId = (_c = object.collectionId) !== null && _c !== void 0 ? _c : "";
        message.itemId = (_d = object.itemId) !== null && _d !== void 0 ? _d : "";
        message.options = (object.options !== undefined && object.options !== null)
            ? exports.GetArchivedOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseGetArchivedResponse() {
    return { item: undefined };
}
exports.GetArchivedResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.item !== undefined) {
            exports.Item.encode(message.item, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetArchivedResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.item = exports.Item.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.GetArchivedResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseGetArchivedResponse();
        message.item = (object.item !== undefined && object.item !== null) ? exports.Item.fromPartial(object.item) : undefined;
        return message;
    },
};
exports.ItemsDefinition = {
    name: "Items",
    fullName: "content.items.Items",
    methods: {
        /** Создать запись */
        create: {
            name: "Create",
            requestType: exports.CreateRequest,
            requestStream: false,
            responseType: exports.CreateResponse,
            responseStream: false,
            options: {},
        },
        /** Валидация данных записи */
        introspect: {
            name: "Introspect",
            requestType: exports.IntrospectRequest,
            requestStream: false,
            responseType: exports.IntrospectResponse,
            responseStream: false,
            options: {},
        },
        /** Получение записи по идентификатору */
        get: {
            name: "Get",
            requestType: exports.GetRequest,
            requestStream: false,
            responseType: exports.GetResponse,
            responseStream: false,
            options: {},
        },
        /** Поиск по текущим записям */
        find: {
            name: "Find",
            requestType: exports.FindRequest,
            requestStream: false,
            responseType: exports.FindResponse,
            responseStream: false,
            options: {},
        },
        update: {
            name: "Update",
            requestType: exports.UpdateRequest,
            requestStream: false,
            responseType: empty_1.Empty,
            responseStream: false,
            options: {},
        },
        delete: {
            name: "Delete",
            requestType: exports.DeleteRequest,
            requestStream: false,
            responseType: empty_1.Empty,
            responseStream: false,
            options: {},
        },
        undelete: {
            name: "Undelete",
            requestType: exports.UndeleteRequest,
            requestStream: false,
            responseType: empty_1.Empty,
            responseStream: false,
            options: {},
        },
        publish: {
            name: "Publish",
            requestType: exports.PublishRequest,
            requestStream: false,
            responseType: empty_1.Empty,
            responseStream: false,
            options: {},
        },
        unpublish: {
            name: "Unpublish",
            requestType: exports.UnpublishRequest,
            requestStream: false,
            responseType: empty_1.Empty,
            responseStream: false,
            options: {},
        },
        getPublished: {
            name: "GetPublished",
            requestType: exports.GetPublishedRequest,
            requestStream: false,
            responseType: exports.GetPublishedResponse,
            responseStream: false,
            options: {},
        },
        findPublished: {
            name: "FindPublished",
            requestType: exports.FindPublishedRequest,
            requestStream: false,
            responseType: exports.FindPublishedResponse,
            responseStream: false,
            options: {},
        },
        checkoutRevision: {
            name: "CheckoutRevision",
            requestType: exports.CheckoutRevisionRequest,
            requestStream: false,
            responseType: exports.CheckoutRevisionResponse,
            responseStream: false,
            options: {},
        },
        /** Расчет значений по существующим данным. Например, получение среднего значения поля */
        aggregate: {
            name: "Aggregate",
            requestType: exports.AggregateRequest,
            requestStream: false,
            responseType: exports.AggregateResponse,
            responseStream: false,
            options: {},
        },
        /** Расчет значений по существующим **опубликованным** данным. */
        aggregatePublished: {
            name: "AggregatePublished",
            requestType: exports.AggregatePublishedRequest,
            requestStream: false,
            responseType: exports.AggregatePublishedResponse,
            responseStream: false,
            options: {},
        },
        getRevision: {
            name: "GetRevision",
            requestType: exports.GetRevisionRequest,
            requestStream: false,
            responseType: exports.GetRevisionResponse,
            responseStream: false,
            options: {},
        },
        listRevisions: {
            name: "ListRevisions",
            requestType: exports.ListRevisionsRequest,
            requestStream: false,
            responseType: exports.ListRevisionsResponse,
            responseStream: false,
            options: {},
        },
        archive: {
            name: "Archive",
            requestType: exports.ArchiveRequest,
            requestStream: false,
            responseType: empty_1.Empty,
            responseStream: false,
            options: {},
        },
        findArchived: {
            name: "FindArchived",
            requestType: exports.FindArchivedRequest,
            requestStream: false,
            responseType: exports.FindArchivedResponse,
            responseStream: false,
            options: {},
        },
        unarchive: {
            name: "Unarchive",
            requestType: exports.UnarchiveRequest,
            requestStream: false,
            responseType: empty_1.Empty,
            responseStream: false,
            options: {},
        },
        getArchived: {
            name: "GetArchived",
            requestType: exports.GetArchivedRequest,
            requestStream: false,
            responseType: exports.GetArchivedResponse,
            responseStream: false,
            options: {},
        },
    },
};
//# sourceMappingURL=items.js.map